import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import backend from './modules/backend'
import frontend from './modules/frontend'

Vue.use(VueRouter)

const routes = [
  ...frontend,
  ...backend,
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to,from, savedPosition){
   
      return to.query["qaf"] && to.query["qaf"]
        ? { x: 0, y: 1046 }
        : { x: 0, y: 0 };
  		
  }
})

export default router
